import { Identifier } from "../../id";
export class PromotionInstanceId extends Identifier {
    constructor(id) {
        super("PromotionInstanceId", id);
    }
}
